( function( $ ) {
	const disabledCSSClass = 'button-qty--disabled';

	const setDefaultDisabledButtonState = () => {
		$( '.quantity input.qty' ).each( function() {
			if ( parseInt ( $( this ).val() ) === 1 ) {
				$( this ).parent().find( '.button-minus' ).addClass( disabledCSSClass );
			}
		} );
	};

	const handleQtyButtons = () => {
		$( document ).on( 'click', '.button-plus, .button-minus', function() {
			$( this ).parent().find( '.' + disabledCSSClass ).removeClass( disabledCSSClass );
			let $quantity = $( this ).parent( '.quantity' ).find( '.qty' );
			let val = parseFloat( $quantity.val().trim() );
			let max = parseFloat( $quantity.attr( 'max' ) );
			let min = parseFloat( $quantity.attr( 'min' ) );
			let step = parseFloat( $quantity.attr( 'step' ) );

			const handlePlus = () => {
				if ( $( this ).is( '.button-plus' ) ) {
					if ( max && ( max <= val ) ) {
						setNumberValue( $quantity, max );
					} else {
						setNumberValue( $quantity, val + step );
						if ( ( val + step ) === max ) {
							$( this ).addClass( disabledCSSClass );
						}
					}
					return;
				}
			};

			const handleMinus = () => {
				if ( $( this ).is( '.button-minus' ) ) {
					if ( min && ( min >= val ) ) {
						setNumberValue( $quantity, min );
					} else if ( val > 1 ) {
						setNumberValue( $quantity, val - step );
						if ( ( val - step ) === min || ( val - step - 1 ) === 0 ) {
							$( this ).addClass( disabledCSSClass );
						}
					}
				}
			};

			handlePlus();
			handleMinus();
		} );

		const setNumberValue = ( $element, number ) => {
			$element.val( parseInt( number ) );
			$element.trigger( 'change' );
		};

		setDefaultDisabledButtonState();
	};

	const preparePlaceholders = () => {
		if ( $( '.woocommerce-cart, .single-product' ).length ) {
			return;
		}

		$( '.woocommerce-edit-account label[for="password_current"], .woocommerce-edit-account label[for="password_1"]' ).each( function() {
			$( this ).html( $( this ).html().replace( 'password', 'Password' ) );
		} );

		$( '.hmt-woocommerce-wrapper' ).find( 'form label' ).each( function() {

			removeNbspFromElement( $( this ) );

			let labelFor = $( this ).attr( 'for' );
			let labelText = $( this )
				.clone()
				.find( '.screen-reader-text' )
				.remove()
				.end()
				.text()
				.replace( '*required', '*' );

			let $input = $( '#' + labelFor );

			if ( $input.length ) {
				if ( $input.attr( 'type' ) === 'number' ) {
					return;
				}

				$( this ).removeClass( 'screen-reader-text' );

				if ( !$input.attr( 'placeholder' ) ) {
					$input.attr( 'placeholder', labelText );
				}
			}
		} );

		$( '.hmt-woocommerce-wrapper' ).find( '#billing_address_1_field, #shipping_address_1_field' ).each( function() {
			if ( !$( this ).hasClass( 'validate-required' ) ) {
				return;
			}

			let $field = $( this ).find( 'input' );

			if ( !$field.length ) {
				return;
			}

			let placeholderValue = $field.attr( 'placeholder' ) + '*';

			$field.attr( 'placeholder', placeholderValue );
			$field.attr( 'data-placeholder', placeholderValue );

		} );
	};

	const prepareSelectFields = () => {
		$( '.hmt-woocommerce-wrapper' ).find( 'form select' ).each( function() {

			let $parent = $( this ).parent();

			if ( $( this ).parent().hasClass( 'woocommerce-input-wrapper' ) ) {
				$parent.addClass( 'woocommerce-input-wrapper--select' );
			}

		} );
	};

	const removeNbspFromElement = ( $element ) => {
		let html = $element.html();

		if ( html && !html.match( /(optional)/g ) ) {
			$element.html( html.replace( '&nbsp;', '' ) );
		}
	};

	const detectCartChange = () => {
		$( document.body ).on( 'updated_cart_totals wc_cart_emptied removed_from_cart added_to_cart wc-blocks_removed_from_cart wc-blocks_added_to_cart', function() {
			updateCartNumber();
			prepareButtonLabels();
			addCartImageHeadline();
			setDefaultDisabledButtonState();
		} );
	};

	const prepareButtonLabels = () => {

		$( '.checkout-button, .wp-element-button span, .cart_totals h2, .woocommerce-page:not(.single-product) h1.wp-block-post-title, .woocommerce input[type=submit], .woocommerce .button[type=submit], .woocommerce-ordering option, .variations option, #ship-to-different-address span, .create-account span, .woocommerce-account label[for="username"], .woocommerce-account label[for="user_login"], .return-to-shop .button' ).each( function() {
			if ( !$( this ).text() ) {
				return;
			}

			$( this ).text( capitalizeText( $( this ).text() ) );
		} );

		setTimeout( function() {
			$( '.wp-element-button span, .woocommerce-order-pay #place_order' ).each( function() {
				$( this ).text( capitalizeText( $( this ).text() ) );
			} );
		}, 1000 );
	};

	const capitalizeText = function( text ) {
		const words = text.trim().split( ' ' );

		const exceptions = ['to', 'and', 'in', 'by', 'an', 'a', 'or', 'with'];

		const result = words.map( ( word ) => {
			if ( exceptions.includes( word.toLowerCase() ) ) {
				return word.toLowerCase();
			} else {
				return word.charAt( 0 ).toUpperCase() + word.slice( 1 ).toLowerCase();
			}
		} ).join( ' ' );

		return result;
	};

	const updateCartNumber = () => {
		const headerIsFound = !!$( '.page-header' ).length;
		const woocommerceIsFound = !!$( '.woocommerce-js' ).length;

		if ( !woocommerceIsFound || !headerIsFound ) {
			return;
		}

		let currentUrl = new URL( window.location.href );
		currentUrl.searchParams.append( 'v', new Date().getTime() );

		$.get( currentUrl, function( data ) {
			$( '.header-theme-cart__quantity' ).text( $( data ).find( '.header-theme-cart__quantity' ).text() );
		} );
	};

	const addCartImageHeadline = () => {
		$( '.woocommerce-cart-form th.product-thumbnail' ).html( 'Image' );
	};

	const checkoutInit = () => {
		$( document ).on( 'init_checkout', function() {
			preparePlaceholders();
		} );
	};

	const alignProductMetaElements = function() {
		$( '.woocommerce-table__product-name .wc-item-meta' ).each( function() {
			let elements = $( this ).find( 'li strong' );

			let maxWidthElement = Math.max.apply( null, elements.map( function() {
				return $( this ).outerWidth( true );
			} ).get() );

			$( elements ).css( 'min-width', maxWidthElement );
		} );
	};

	const excludeSearchFormFields = function() {
		let $searchForm = $( '.hmt-product-search' );

		if ( $searchForm ) {
			$searchForm.on( 'submit', function() {
				$searchForm.find( 'input' ).each( function() {
					if ( $( this ).attr( 'name' ).match( /ct_/i ) ) {
						$( this ).remove();
					}
				} );
			} );
		}
	};

	const handleOrderBy = () => {
		/**
		 * Turn on the custom scrollbar for the dropdown.
		 */
		$( '.woocommerce-ordering__dropdown' ).each( ( _, dropdown ) => {
			window.app.main.customScrollbarsForSection( dropdown );
		} );

		/**
		 * Handle the outside click.
		 */
		$( document ).on( 'click', function( event ) {
			const $dropdown = $( '.woocommerce-ordering__dropdown' );
			const $trigger = $( '.woocommerce-ordering__trigger' );

			const isClickOutsideDropdown = !$dropdown.is( event.target ) && $dropdown.has( event.target ).length === 0;
			const isClickOutsideTrigger = !$trigger.is( event.target ) && $trigger.has( event.target ).length === 0;
			const isDropdownVisible = $dropdown.is( ':visible' );

			if ( isClickOutsideDropdown && isClickOutsideTrigger && isDropdownVisible ) {
				$dropdown.slideUp( 200 );
			}
		} );

		/**
		 * Handle the click event on the trigger.
		 */
		$( '.woocommerce-ordering__trigger' ).on( 'click', function( event ) {
			event.preventDefault();

			const $trigger = $( this );
			const $dropdown = $trigger.next( '.woocommerce-ordering__dropdown' );

			$dropdown.slideToggle( 200 );
		} );
	};

	alignProductMetaElements();
	prepareButtonLabels();
	preparePlaceholders();
	prepareSelectFields();
	handleQtyButtons();
	detectCartChange();
	updateCartNumber();
	addCartImageHeadline();
	checkoutInit();
	excludeSearchFormFields();
	handleOrderBy();
} )( jQuery );
